import Quill from 'quill';
const Block = Quill.import('blots/block') as any;

export class QuillDivBlock extends Block {
  static tagName = 'DIV';
}
